let isLoading = false;
let listeners = [];
let timeoutId = null;  // To store the timeout ID for clearing it
let showLoaderTimeout = 1500;  // 1500 ms delay for showing the loader

// function to subscribe to the changes in isLoading
export const subscribeToLoading = (callback) => {
    listeners.push(callback);
    return () => {
        listeners = listeners.filter(listener => listener !== callback);
    };
};

// Function to update isLoading and notify to all subscribers
export const setisLoading = (loading) => {
    // Clear the previous timeout if it's still pending
    if (timeoutId) {
        clearTimeout(timeoutId);
    }

    if (loading) {
        // If we're setting loading to true, wait for 1500ms
        timeoutId = setTimeout(() => {
            isLoading = true;
            // Notify all subscribers only after the timeout
            listeners.forEach((listener) => listener(isLoading));
        }, showLoaderTimeout);
    } else {
        // If we're setting loading to false, immediately set isLoading to false
        isLoading = false;
        listeners.forEach((listener) => listener(isLoading));
    }
};

// Get current state
export const getIsLoading = () => isLoading;
